/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';
import { Container } from './styles/Container.styled';
import { FServices, FBoxList, FBox, UlList, LiList } from './styles/TypesOfCompaniesBlock.styled';

export default function CompaniesTypesBlock({ data, dir }) {
  return (
    <Container>
      <FServices>
        <FBoxList>
          {data.companyTypes.map(({ content: { title, features } }) => (
            <FBox dir={dir}>
              <h3 dir={dir}>{title}</h3>
              <UlList dir={dir}>
                {features.map(({ content: { title: label, link } }) => (
                  <LiList>
                    {label}{' '}
                    {link && (
                      <a target={link.target || '_blank'} href={link.url}>
                        ({link.name}).
                      </a>
                    )}
                  </LiList>
                ))}
              </UlList>
            </FBox>
          ))}
        </FBoxList>
      </FServices>
    </Container>
  );
}
